<div class="tourPopUp">
  <nb-card class="p-0">
    <h2 mat-dialog-title>
      <div class="pull-right">
        <a class="boxclose" (click)="onNoClick(false)"></a>
      </div>
    </h2>
    <mat-dialog-content class="mat-typography">
      <div class="col-md-12">
        <h2 class="col-12 text-center"><b>Welcome to the TTN Fleet Solutions Client Portal</b></h2>
        <h4 class="col-12 text-center"> {{followStepsMessage}}</h4>
      </div>
    </mat-dialog-content>
  </nb-card>
</div>